export type RoomsSectionTitleVariant =
  | 'bookOnVio'
  | 'bookOnVioPoweredBy'
  | 'availableRooms'

type Params = {
  showVioBrandedRoomsTitle: boolean
  isCoBranded: boolean
  isRoomsListImprovementsB: boolean
}

/**
 * The B side of the rooms list improvements replaces the Vio branded title
 * with the available rooms count, whatever the room count.
 */
export const getRoomsSectionTitleVariant = ({
  showVioBrandedRoomsTitle,
  isCoBranded,
  isRoomsListImprovementsB
}: Params): RoomsSectionTitleVariant => {
  if (showVioBrandedRoomsTitle) {
    return isRoomsListImprovementsB ? 'availableRooms' : 'bookOnVio'
  }
  if (isCoBranded) return 'bookOnVioPoweredBy'
  return 'availableRooms'
}
